import { render, staticRenderFns } from "./AddPersonModal.vue?vue&type=template&id=e62079d2"
import script from "./AddPersonModal.vue?vue&type=script&lang=ts"
export * from "./AddPersonModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports